
###
# Модель категории
###
App.Category = DS.Model.extend
  menu_order    : DS.attr 'number'
  is_hidden     : DS.attr 'boolean'
  is_list       : DS.attr 'boolean'
  export_hidden_sources : DS.attr 'string'
  name          : DS.attr 'string'
  photo         : DS.attr 'mixed'
  menu_order    : DS.attr 'number'
  external_id   : DS.attr 'string'
  comment       : DS.attr 'string'

  level         : DS.attr 'number'

  # Внешние связи
  dishes        : DS.hasMany   'dish', async: true
  organization  : DS.belongsTo 'organization', async: true

  parent        : DS.belongsTo 'category', async: false, inverse: 'categories'
  categories    : DS.hasMany   'category',   async: true, inverse: 'parent'

  is_root       : Em.computed.not('parent')

  name_for_tree: ( ->
    "#{'      '.repeat(@get('level'))} #{@get('name')}"
  ).property('name', 'level')
